import React from "react";
import { useAuthProvider } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";



const AuthNotSupported = ({page, basename, history}) => {
    const [ authorized, authType ] = useAuthProvider();
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <Grid item xs={12} md={7} lg={5} mr="auto" position="relative">
                    {authType.substring(0, 1).toUpperCase()+authType.substring(1)} authentication not supported for this feature.
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default AuthNotSupported;